import lang from '../i18n/index'
import { Toast, Dialog } from 'vant';

let failDialogList = [10112502, 10112503]
let tipList = [500, 10112201, 10112202, 10112203, 10112207, 10111402, 10111403, 500006, 500007, 500003, 500009, 500014, 500015, 500018]

export default function requestFail(val) {
  if (failDialogList.includes(val)) {
    Dialog.alert({
      message: lang.messages[lang.locale][val],
      confirmButtonText: this.$t('confirm')
    }).then(() => {
      // on close
      switch (val) {
        case 10112502:
          localStorage.clear()
          location.reload()
          break
        case 10112503:
          localStorage.clear()
          cancelClick()
          break
      }
    });
  } else if (tipList.includes(val)) {
    Toast.fail({
      message: lang.messages[lang.locale][val],
      forbidClick: true,
    })
  } else {
    Toast.fail({
      message: lang.messages[lang.locale][500],
      forbidClick: true,
    })
  }
}

function cancelClick() {
  switch (getSystem()) {
    case 'iphone':
      window.location.href = 'iosn://pd_actv_cancel';
      break;
    case 'android':
      window.pdActv['cancel']();
      break;
    case 'u3dPc':
      window['pdActv_cancel']();
      break;
    case 'mac':
      window.webkit.messageHandlers.onClose.postMessage("");
      break;
    default:
      alert('callback SDK to cancel');
  }
}
function getSystem() {
  var osUserAgent = navigator.userAgent.toLowerCase();
  if (
    osUserAgent.indexOf('iphone') > -1 ||
    osUserAgent.indexOf('ipad') > -1 ||
    osUserAgent.indexOf('ipod') > -1
  ) {
    return 'iphone';
  } else if (
    osUserAgent.indexOf('android') > -1 ||
    osUserAgent.indexOf('adr') > -1
  ) {
    return 'android';
  } else if (osUserAgent.indexOf('awesomium') > -1) {
    return 'u3d';
  } else if (osUserAgent.indexOf('untiypcsdk') > -1) {
    return 'u3dPc';
  } else if (osUserAgent.indexOf("pd_mac_sdk") > -1) {
    return 'mac';
  } else {
    return 'windows';
  }
}
